<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Upload/Lift",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Upload/Lift",
      items: [
        {
          text: "Home",
        },
         {
          text: "Apprehension",
        },
        {
          text: "Upload/Lift",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>